import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";

import { User } from "../_models";

@Injectable()
export class UserService {
    constructor(private http: Http) {
    }


}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/_services/user.service.ts